import { render, staticRenderFns } from "./AllBudgetTransactionTable.vue?vue&type=template&id=50d1d696&"
import script from "./AllBudgetTransactionTable.vue?vue&type=script&lang=js&"
export * from "./AllBudgetTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports